"use client"

import { useEffect } from 'react'

export function PerformanceMonitor() {
  useEffect(() => {
    // Only run in development
    if (process.env.NODE_ENV !== 'development') return

    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === 'navigation') {
          const navEntry = entry as PerformanceNavigationTiming
          console.log('🚀 Navigation Performance:', {
            'DOM Content Loaded': `${navEntry.domContentLoadedEventEnd - navEntry.domContentLoadedEventStart}ms`,
            'Load Complete': `${navEntry.loadEventEnd - navEntry.loadEventStart}ms`,
            'First Paint': `${navEntry.responseEnd - navEntry.requestStart}ms`,
            'Total Load Time': `${navEntry.loadEventEnd - navEntry.fetchStart}ms`
          })
        }
        
        if (entry.entryType === 'largest-contentful-paint') {
          console.log('🎨 LCP:', `${entry.startTime}ms`)
        }
        
        if (entry.entryType === 'first-input') {
          const fidEntry = entry as PerformanceEventTiming
          console.log('⚡ FID:', `${fidEntry.processingStart - fidEntry.startTime}ms`)
        }
      }
    })

    observer.observe({ entryTypes: ['navigation', 'largest-contentful-paint', 'first-input'] })

    return () => observer.disconnect()
  }, [])

  return null
}
